// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const googleMaps: Styleguide["googleMap"] = {};

export default googleMaps;
